module.exports = __webpack_public_path__ + "img/quicktips12.afc5aa95.svg";